"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FeSideNavList = _interopRequireDefault(require("./FeSideNavList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FeSideNav = function FeSideNav(_ref) {
  var navList = _ref.navList,
      navHeaderContent = _ref.navHeaderContent,
      navFooterContent = _ref.navFooterContent,
      withSearch = _ref.withSearch,
      customRenderLink = _ref.customRenderLink,
      productType = _ref.productType;
  return _react.default.createElement("div", {
    className: "fe-container"
  }, _react.default.createElement("nav", {
    className: "fe-side-nav"
  }, productType ? _react.default.createElement("span", {
    className: "fe-product fe-product--".concat(productType, "-horizontal")
  }) : null, navHeaderContent && _react.default.createElement("div", {
    className: "fe-side-nav__header"
  }, _react.default.createElement("div", {
    className: "fe-top-nav__title"
  }, navHeaderContent)), _react.default.createElement("div", {
    className: "fe-side-nav__nav-container"
  }, _react.default.createElement(_FeSideNavList.default, {
    withSearch: withSearch,
    navList: navList,
    customRenderLink: customRenderLink
  }), navFooterContent && _react.default.createElement("div", {
    className: "fe-side-nav__footer"
  }, navFooterContent))));
};

FeSideNav.defaultProps = {
  withSearch: false,
  navList: [],
  navHeaderContent: null,
  navFooterContent: null,
  customRenderLink: null,
  productType: null
};
FeSideNav.propTypes = {
  /** Array of navigation items */
  navList: _propTypes.default.array.isRequired,

  /** Content for the header section */
  navHeaderContent: _propTypes.default.node,

  /** Content for the footer section */
  navFooterContent: _propTypes.default.node,

  /** Set to true to have seacrh box for nav items */
  withSearch: _propTypes.default.bool,

  /** A function that returns a react element to render the wrapping link.
   *  Will receive url, className, and children props
   */
  customRenderLink: _propTypes.default.func,

  /** Provide productType like 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta'*/
  productType: _propTypes.default.oneOf(['alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta'])
};
var _default = FeSideNav;
exports.default = _default;